/* eslint-disable consistent-return */
export function groupMakeFn(item: any) {
  if (item.charAt(0) >= "A" && item.charAt(0) <= "D") {
    return "A - D";
  } if (item.charAt(0) >= "E" && item.charAt(0) <= "I") {
    return "E - I";
  } if (item.charAt(0) >= "J" && item.charAt(0) <= "L") {
    return "J - L";
  } if (item.charAt(0) >= "M" && item.charAt(0) <= "P") {
    return "M - P";
  } if (item.charAt(0) >= "Q" && item.charAt(0) <= "Z") {
    return "Q - Z";
  }
}
